import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

import './ChangePasswordForm.css';

const ChangePasswordForm = () => {
  const [show, setShow] = useState(true);

  const handleClose = () => setShow(false);

  return (
    <div className="change-password-form">
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title><FontAwesomeIcon icon={faLock} /> Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="formChangePasswordCurrentPassword">
              <Form.Label>Current Password</Form.Label>
              <Form.Control type="password" placeholder="Current Password" />
            </Form.Group>
            <Form.Group controlId="formChangePasswordNewPassword">
              <Form.Label>New Password</Form.Label>
              <Form.Control type="password" placeholder="New Password" />
            </Form.Group>
            <Form.Group controlId="formChangePasswordConfirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control type="password" placeholder="Confirm Password" />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" href="/password-changed-successfully" onClick={handleClose}>
            Change Password
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ChangePasswordForm;